import React from "react";

type ThumbnailIconProps = {
    className?: string;
};

export const ThumbnailIcon: React.FC<ThumbnailIconProps> = ({ className }) => (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={`w-5 h-4 ${className ?? ''}`}>
        <path d="M2.1999 15.1998C1.7049 15.1998 1.28115 15.0235 0.928652 14.6708C0.576152 14.3181 0.399902 13.8941 0.399902 13.3988V2.5928C0.399902 2.09747 0.576152 1.6748 0.928652 1.3248C1.28115 0.974805 1.7049 0.799805 2.1999 0.799805H17.7999C18.2949 0.799805 18.7187 0.976137 19.0712 1.3288C19.4237 1.68147 19.5999 2.10547 19.5999 2.6008V13.4068C19.5999 13.9021 19.4237 14.3248 19.0712 14.6748C18.7187 15.0248 18.2949 15.1998 17.7999 15.1998H2.1999ZM7.5999 13.3998H17.7999V2.5998H7.5999V13.3998ZM5.7999 13.3998V2.5998H2.1999V13.3998H5.7999Z" fill="currentColor"/>
    </svg>
);